import client from "./clients/portalClient";

const getCetDashboard = () => client.get(`/engineering/cet_dashboard`);
const editEngineering = (id, data) => client.put(`/projects/${id}/cet`, data);


const engineeringApi = {
    getCetDashboard,
    editEngineering
};

export default engineeringApi;
